// Full view-option lists for the menu-test block, ported from menu_test/lib.coffee
// (menuViewOptions / sectionViewOptions / productViewOptions with listText+help, the
// delivery-option labels and the default view constants). Single source for controls,
// the param grammar and the charts (yAxis titles).

export const VIEW_MODES = {
  AMOUNT: 'amount',
  OPENED: 'opened',
  PURCHASED: 'purchased',
  P_VOLUME: 'pVolume',
  P_AMOUNT: 'pAmount',
  ATTENTION: 'attention',
  TIME_TO_FIRST_CLICK: 'timeToFirstClick',
  TIME: 'time'
}

// The respondent-count view modes — the ones with percents, MoE and the full 4-mode
// selector (legacy keys every branch on them). Products have a single such mode; sections
// have two, both counting respondents against the question base.
export const PRODUCT_PERCENT_CAPABLE_VIEWS = [VIEW_MODES.AMOUNT]
export const SECTION_PERCENT_CAPABLE_VIEWS = [VIEW_MODES.OPENED, VIEW_MODES.PURCHASED]

export const DEFAULT_MENU_VIEW = 'sheatmap'
export const DEFAULT_SECTION_VIEW = 'opened'
export const DEFAULT_PRODUCT_VIEW = 'amount'

// sq{n}.amount counts the openers, not the purchasers
export const purchasedCount = node => Math.max(0, (node?.amount || 0) - (node?.totalPickedUp || 0))

export const MENU_VIEW_OPTIONS = [
  {
    text: 'Menu Heatmap by sections',
    value: 'sheatmap',
    listText: 'Menu Heatmap by sections',
    help: '<strong>Menu Heatmap by sections</strong><br/> A graphic visualization of the density of clicks on a specific section.'
  },
  {
    text: 'Menu Heatmap by clicks',
    value: 'heatmap',
    listText: 'Menu Heatmap by clicks',
    help: '<strong>Menu Heatmap by clicks</strong><br/> A graphic visualization of the density of clicks on the menu. This view is a rendering of the programmed menu and does not account for any randomization or logic.'
  },
  {
    text: 'Clicks',
    value: 'clicks',
    listText: 'Clicks',
    help: '<strong>Clicks</strong><br/> The precise coordinates of every click on the menu. This view is a rendering of the programmed menu and does not account for any randomization or logic.'
  },
  {
    text: 'Plain image with sections',
    value: 'plain',
    listText: 'Plain image with sections',
    help: '<strong>Plain image with sections</strong><br/> This view represents a rendering of a menu as it was originally programmed, with the section areas outlined.'
  }
]

export const SECTION_VIEW_OPTIONS = [
  {
    text: 'Respondents opened section',
    value: 'opened',
    listText: 'Respondents opened section',
    help: '<strong>Respondents opened section</strong><br/> The proportion of respondents who opened this section.'
  },
  {
    text: 'Respondents purchased from section',
    value: 'purchased',
    listText: 'Respondents purchased from section',
    help: '<strong>Respondents purchased from section</strong><br/> The proportion of respondents who purchased at least one menu item from this section.'
  },
  {
    text: 'Purchase quantity',
    value: 'pVolume',
    listText: 'Purchase quantity',
    help: '<strong>Purchase quantity</strong><br/> The average number of menu items purchased from this section.'
  },
  {
    text: 'Section purchase amount',
    value: 'pAmount',
    listText: 'Section purchase amount',
    help: '<strong>Section purchase amount</strong><br/> The average spend on this section, among those who purchased from it.'
  },
  {
    text: 'Attention span',
    value: 'attention',
    listText: 'Attention span',
    help: '<strong>Attention span</strong><br/> The average time a respondent spent viewing this section, among those who opened it.'
  },
  {
    text: 'Time to first click',
    value: 'timeToFirstClick',
    listText: 'Time to first click',
    help: '<strong>Time to first click</strong><br/> The average time between entering the exercise and clicking on this section for the first time.'
  },
  {
    text: 'Time to order',
    value: 'time',
    listText: 'Time to order',
    help: '<strong>Time to order</strong><br/> The average time between entering the exercise and adding the first item from this section to the order, among those who purchased from it.'
  }
]

export const PRODUCT_VIEW_OPTIONS = [
  {
    text: 'Purchase selection',
    value: 'amount',
    listText: 'Purchase selection',
    help: '<strong>Purchase selection</strong><br/> The proportion of respondents who purchased a menu item.'
  },
  {
    text: 'Purchase quantity',
    value: 'pVolume',
    listText: 'Purchase quantity',
    help: '<strong>Purchase quantity</strong><br/> The average number of a menu item purchased, among those who purchased it.'
  },
  {
    text: 'Purchase amount',
    value: 'pAmount',
    listText: 'Purchase amount',
    help: '<strong>Purchase amount</strong><br/> The average spend on a menu item, among those who purchased it.'
  },
  {
    text: 'Time to order',
    value: 'time',
    listText: 'Time to order',
    help: '<strong>Time to order</strong><br/> The average time between entering the exercise and adding a menu item to the order, among those who purchased it.'
  }
]

export const DELIVERY_OPTION_LABELS = {
  dinein: 'Dine in',
  drivethru: 'Drive thru',
  pickup: 'Pick up',
  delivery: 'Delivery'
}

// raw delivery option codes → dropdown-friendly objects (Lib.getDeliveryOptions port)
export const getDeliveryOptions = (deliveryOptions = []) =>
  deliveryOptions.map(opt => ({ text: DELIVERY_OPTION_LABELS[opt] || opt, value: opt }))
